/**
 * Created by rxsl-101 on 2018/7/24.
 */
import { Utils } from '../../app.base'
import { MsgBox, Vue } from '../../app.vues';

import SwbCustXportConfCrud from './CustXportConfCrud.vue'

//打开导入模板定制化对话框 callback(custConf, theDlg)
export function showCustXportConfDlg(dlgConfig, callback) {
    Vue.regist(SwbCustXportConfCrud);
    //
    dlgConfig = dlgConfig || {};
    let dlgTitle = dlgConfig.dlgTitle || '导入模板 - 定制化';
    let dlgWidth = dlgConfig.dlgWidth || 900;
    let dlgHeight = dlgConfig.dlgHeight || -100;
    //
    let editMode = dlgConfig.editMode || false;
    let metaConf = dlgConfig.metaConf || {};
    let custConf = dlgConfig.custConf || {};
    //
    let theDlg = Vue.$showDialog({
        title: dlgTitle,
        width: dlgWidth,//80%
        height: dlgHeight,//80%
        okVisible: editMode ? true : false,
        cancelVisible: editMode ? true : false,
        centerButtons: true,
        showCloseBtn: true,
        template: '<swb-cust-xport-conf-crud  ref="theCtrl" :editMode="editMode" :metaConf="metaConf" :custConf="custConf"></swb-cust-xport-conf-crud>',
        data: {
            editMode: editMode,
            metaConf: metaConf,
            custConf: custConf
        },
        okClicked: function () {
            let theCtrl = this.$refs['theCtrl'];
            let custConf = theCtrl.getCustConf();
            if(typeof callback == 'function') {
                callback(custConf, theDlg);
            }
            return false;
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/comn/showDlg.js
// module id = 4658
// module chunks = 0